import { render, staticRenderFns } from "./AccountantDossierSettings.vue?vue&type=template&id=cfe45d6c&scoped=true"
import script from "./AccountantDossierSettings.vue?vue&type=script&lang=ts"
export * from "./AccountantDossierSettings.vue?vue&type=script&lang=ts"
import style0 from "./AccountantDossierSettings.vue?vue&type=style&index=0&id=cfe45d6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe45d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe45d6c')) {
      api.createRecord('cfe45d6c', component.options)
    } else {
      api.reload('cfe45d6c', component.options)
    }
    module.hot.accept("./AccountantDossierSettings.vue?vue&type=template&id=cfe45d6c&scoped=true", function () {
      api.rerender('cfe45d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantDossierSettings.vue"
export default component.exports